export const rarities = [
  'Comum',
  'Incomum',
  'Raro',
  'Muito Raro',
  'Lendário',
  'Artefato',
  'Único',
]

export const types = [
  'Anel',
  'Arma',
  'Armadura',
  'Benção',
  'Cajado',
  'Habilidade',
  'Item Maravilhoso',
  'Pergaminho',
  'Poção',
  'Varinha',
]

export const margin = 10

const getOrientation = (width, height) => ({
  height,
  width,
  availableHeight: (height - (margin * 2)),
  availableWidth: (width - (margin * 2))
})

const getFormat = (width, height) => ({
  portrait: getOrientation(width, height),
  landscape: getOrientation(height, width),
})

export const formats = {
  a4: getFormat(210, 297),
  a3: getFormat(297, 420),
}

export const orientations = [
  'portrait',
  'landscape'
]

export const titleNameSizes = [
  {name: 'Miúdo', value: 'tiny'},
  {name: 'Pequeno', value: 'small'},
  {name: 'Mediano', value: 'medium'},
  {name: 'Grande', value: 'large'},
  {name: 'Enorme', value: 'huge'},
]

export const textSizes = [
  {name: 'Mediano', value: 'medium'},
  {name: 'Pequeno', value: 'small'},
  {name: 'Miúdo', value: 'tiny'}
]

export const spacing = 5

export const initialItemData = {
  uuid: null,
  name: 'Meu novo artefato',
  type: types[1],
  subType: '',
  rarity: rarities[0],
  description: '',
  effects: '',
  requiresAttunement: false,
  file: null,
  backgroundColor: '#ffffff',
  backgroundSize: 'cover',
  backgroundPositionX: 50,
  backgroundPositionY: 50,
  showLevels: true,
  textSize: textSizes[0],
  titleNameSize: titleNameSizes[2]
}